import * as React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

// Shards-React Components
import { Row, Col, Container } from "shards-react"

const RefundPage = props => (
  <Layout countryCode={props.pageContext.countryCode || "JM"}>
    <SEO
      title="Refund Policy"
      description="Refund polciy effective January 1, 2020."
      countryCode={props.pageContext.countryCode || "JM"}
    />

    <Container>
      <br />
      <h3>Refund Policy</h3>
      <br />

      <Row>
        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.1</p>
        </Col>
        <Col xs={11}>
          <p>
            Students are only eligible for a refund if they are in good
            financial standing with the Institution.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.2</p>
        </Col>
        <Col xs={11}>
          <p>
            Students are eligible for a refund if the scheduled programme/course
            is cancelled by the Institution.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.3</p>
        </Col>
        <Col xs={11}>
          <p>
            Students are eligible for a refund of a portion of tuition costs if
            they withdraw from the Institution or request Leave of Absence in
            writing before the end of the third week of semester classes.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.4</p>
        </Col>
        <Col xs={11}>
          <p>
            Students may be eligible for a refund of a portion of tuition costs
            if they change their registration by dropping a course before the
            end of the third week of semester classes.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.5</p>
        </Col>
        <Col xs={11}>
          <p>
            Tuition and fees are neither refundable nor transferable after the
            end of the third week of semester classes.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.6</p>
        </Col>
        <Col xs={11}>
          <p>
            Only tuition fees and exam fees are refundable. Other fees are
            non-refundable unless stated otherwise.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.7</p>
        </Col>
        <Col xs={11}>
          <p>
            Examination fees, where payable, cannot be transferred from one
            examination to another and can be returned only under exceptional
            circumstances by approval of the Academic Board.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.8</p>
        </Col>
        <Col xs={11}>
          <p>
            Fees are not refundable if a student is required to withdraw or is
            suspended for academic or disciplinary reasons.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.9</p>
        </Col>
        <Col xs={11}>
          <p>
            Fees are not refundable if operations are suspended due to an act of
            nature, civil disturbance or any reason beyond the control of the
            Institution.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.10</p>
        </Col>
        <Col xs={11}>
          <p>Fees are refundable in the currency of original payment only. </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.11</p>
        </Col>
        <Col xs={11}>
          <p>Refund of tuition is pro-rated as follows:</p>

          <p>Before the end of week 1 - 100% refund</p>
          <p>Before the end of week 2 - 75% refund</p>
          <p>Before the end of week 3 - 50% refund</p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.12</p>
        </Col>
        <Col xs={11}>
          <p>
            Incomplete forms or forms submitted without the required supporting
            documents will not be processed.
          </p>
        </Col>

        <Col xs={1}>
          <p className="text-primary font-weight-bold">1.13</p>
        </Col>
        <Col xs={11}>
          <p>
            Refunds will only be processed after the end of the registration
            period each semester or summer or 60 days after request.
          </p>
        </Col>
      </Row>
    </Container>
  </Layout>
)

export default RefundPage
